export default __webpack_public_path__ + "static/media/raasi-home.1b57c68b.png";